import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { createSearchParams, useNavigate } from 'react-router-dom';
import AssetItem from '../../../../components/AssetItem';
import AppConfig from '../../../../config';
import './PortfolioAssets.scss';

const { routes } = AppConfig;

const PortfolioAssets = ({ portfolioId }) => {
	const currencies = useSelector(state => state?.app?.currencies);
	const availableCurrencies = useSelector(state => state?.app?.availableCurrencies);
	const viewsBalances = useSelector(state => state?.app?.viewsBalances);
	const navigate = useNavigate();

	const currenciesInfo = currencies?.map(currency => {
		const availableCurrency =
			availableCurrencies?.filter(availableCurr => availableCurr?.CurrencyId === currency?.Id)[0] || {};
		const currency_ = currency || {};
		return { ...currency_, ...availableCurrency };
	});

	const sortedCurrencies = currenciesInfo?.sort((a, b) => {
		if (a?.AmountUsd < b?.AmountUsd) return 1;
		if (a?.AmountUsd > b?.AmountUsd) return -1;
		return 0;
	});

	const onAssetClick = asset => {
		navigate({
			pathname: routes.assets,
			search: createSearchParams({ portfolio: portfolioId }).toString(),
			hash: asset?.Symbol,
		});
	};

	useEffect(() => {
		const ensureDocumentIsScrollable = () => {
			const isScrollable = document.documentElement.scrollHeight > window.innerHeight;
			if (!isScrollable) {
				document.documentElement.style.setProperty('height', 'calc(100vh + 1px)', 'important');
			}
		};
		const preventCollapse = () => {
			if (window.scrollY === 0) window.scrollTo(0, 1);
		};

		const scrollableElement = document.querySelector('.PortfolioAssets');
		scrollableElement.addEventListener('touchstart', preventCollapse);

		if (document.readyState === 'complete') {
			ensureDocumentIsScrollable();
		} else {
			window.addEventListener('load', ensureDocumentIsScrollable);

			return () => {
				window.removeEventListener('load', ensureDocumentIsScrollable);
			};
		}
	});

	return (
		<div className='PortfolioAssets'>
			{sortedCurrencies?.map(asset => (
				<AssetItem
					key={asset?.Id}
					currencyName={asset?.Name}
					currencySymbol={asset?.Symbol}
					accountsAmount={asset?.AddressesCount}
					balance={asset?.Amount}
					balanceFiat={asset?.AmountUsd}
					viewsBalances={viewsBalances}
					onClick={() => onAssetClick(asset)}
				/>
			))}
		</div>
	);
};

export default PortfolioAssets;
